<template>
  <g class="falla-strut-1000">
  <g class="stag-crosses">
    <polygon class="cross" points="863.53 2799.57 1521.71 2119.57 1553.38 2164.07 895.20 2844.07" fill="#3f7fbb"/>
    <polygon class="cross" points="895.20 1757.85 1553.38 3197.85 1521.71 3205.79 863.53 1765.79" fill="#3f7fbb"/>
  </g>
  <g class="stag-bar-lower">
    <polygon class="topside" points="818.74 2786.82 1598.17 3236.82 1611.16 3229.32 831.73 2779.32" fill="#dde2e5"/>
    <polygon class="frontside" points="818.74 2856.82 1598.17 3306.82 1598.17 3236.82 818.74 2786.82" fill="#c3cace"/>
    <polygon class="main-rightside" points="1598.17 3306.82 1611.16 3299.32 1611.16 3229.32 1598.17 3236.82" fill="#b8bfc4"/>
  </g>
  <g class="stag-bar-upper">
    <polygon class="topside" points="818.74 1656.82 1598.17 2106.82 1611.16 2099.32 831.73 1649.32" fill="#dde2e5"/>
    <polygon class="frontside" points="818.74 1726.82 1598.17 2176.82 1598.17 2106.82 818.74 1656.82" fill="#c3cace"/>
    <polygon class="main-rightside" points="1598.17 2176.82 1611.16 2169.32 1611.16 2099.32 1598.17 2106.82" fill="#b8bfc4"/>
  </g>
  </g>
</template>
<script>
export default {
  name: "Strut1000-F.vue",
};
</script>
